module.exports = __webpack_public_path__ + "img/img_4.e06241f3.jpg";